import { adWrap } from "src/tags/ads/index"

export const InterstitialAd = () => {
  return adWrap.InterstitialAd({
    ios: "/13341826/a_rakuraku.ios_Plus_interstitialvideo",
    android: "/13341826/a_rakuraku.and_Plus_interstitialvideo",
  })()
}
